export default {
    dev: {
      apiURL: 'http://localhost:3402'
    },
    stg: {
      apiURL: 'https://api-io-stg.worldify.multiplymii.com/v1'
    },
    prod: {
      apiURL: 'https://api-io.worldify.multiplymii.com/v1'
    },    
  }